const MAX_WIDTH_MOBILE = 1023;
const MAX_WIDTH_TABLET = 1379;

const getWidth = () => window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;

export const isMobile = () => getWidth() <= MAX_WIDTH_MOBILE;
export const isTablet = () => getWidth() > MAX_WIDTH_MOBILE && getWidth() <= MAX_WIDTH_TABLET;

export const getViewportHeight = () => window.innerHeight || document.documentElement.clientHeight;

export const setCustomHeightVariable = () => {
    const vh = window.innerHeight * 0.01;
    // Then we set the value in the --vh custom property to the root of the document

    document.documentElement.style.setProperty('--vh', `${vh}px`);
};
